import { fromTriggerOptionId } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/operator-trigger-id.business';

// A trigger left behind by a deselected device type would be invisible and still saved.
export const retainTriggersOfDeviceTypes = (triggerOptionIds: string[], deviceTypeIds: string[]): string[] => {
    const retainedDeviceTypeIds = new Set(deviceTypeIds);

    return triggerOptionIds.filter((optionId) => {
        const pair = fromTriggerOptionId(optionId);

        return pair ? retainedDeviceTypeIds.has(pair.deviceTypeId) : false;
    });
};
